import styled, { css } from "styled-components";
import { colors, media, getOuterSpace } from "../../style/constants";

export const Wrapper = styled.div`
  ${media.md`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 10;
  `};
  ${media.sm`
    position: fixed;
  `};
`;

export const Shoable = styled.div`
  ${media.md`
    overflow: hidden;
    transition: max-height .6s cubic-bezier(0.45, 0, .1, 1);
    will-change: max-height;
    margin-top: 1rem;
    max-height: 200px;
    
    > div {
      padding: 1.5rem 3rem 0.5rem;
    }
  `} ${media.sm`
    > div {
      padding: 0 1.5rem .5rem;
    }
  `};
`;

export const Header = styled.header`
  ${media.md`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    min-height: 2rem;
    ${getOuterSpace("padding")};
    padding-bottom: 1rem !important;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/Navigation/style.js